// Passed as the context of a query whose screen shows its own error state
// (a full-page error, an inline "Try again"), so the error link doesn't also
// show a toast for it.
export const SKIP_ERROR_TOAST_CONTEXT = { shouldSkipErrorToast: true };
